import { Filter } from '~/shared/ui/AsyncGrid/types'

export const filters: Filter[] = [
  {
    field: 'name',
    label: 'filter.designation',
    type: 'text',
  },
]
